import { requestJson } from "@/lib/api";

export interface DeliveryUnitSalesSummary {
  deliveryUnitId: string | null;
  deliveryUnitName: string;
  orders: number;
  totalValue: number;
  deliveredValue: number;
  pendingValue: number;
}

export interface ClientSalesSummary {
  clientId: string;
  clientName: string;
  orders: number;
  totalValue: number;
  deliveredValue: number;
  pendingValue: number;
  commissionPercent?: number | null;
  commissionAmount?: number | null;
  byDeliveryUnit: DeliveryUnitSalesSummary[];
}

export interface SalesReport {
  vendorId: string | null;
  vendorName: string | null;
  periodFrom: string | null;
  periodTo: string | null;
  totalOrders: number;
  totalValue: number;
  deliveredValue: number;
  pendingValue: number;
  commissionTotal?: number | null;
  byClient: ClientSalesSummary[];
}

export interface VendorSummary {
  id: string;
  name: string;
  email: string;
  commissionPercent?: number | null;
}

export async function fetchSalesReport(params: {
  from?: string;
  to?: string;
  vendorId?: string;
}): Promise<SalesReport> {
  const qs = new URLSearchParams();
  if (params.from) qs.set("from", params.from);
  if (params.to) qs.set("to", params.to);
  if (params.vendorId) qs.set("vendorId", params.vendorId);
  const query = qs.toString();
  return requestJson<SalesReport>(`/api/v1/reports/sales${query ? `?${query}` : ""}`);
}

export async function fetchVendors(): Promise<VendorSummary[]> {
  return requestJson<VendorSummary[]>("/api/v1/reports/sales/vendors");
}

export interface ClientOrderRow {
  orderId: string;
  orderNumber: number | null;
  createdDate: string | null;
  exitDate: string | null;
  value: number;
  status: string;
}

export interface ClientProductRow {
  productId: string;
  productName: string;
  unit: string;
  orderCount: number;
  totalQuantity: number;
  totalValue: number;
}

export interface ClientOrdersReport {
  clientId: string;
  clientName: string | null;
  orders: ClientOrderRow[];
  products: ClientProductRow[];
}

/** Pedidos de um cliente no período (não cancelados) + agregação por produto. Herda o escopo do relatório. */
export async function fetchClientOrders(
  clientId: string,
  params: { from?: string; to?: string },
): Promise<ClientOrdersReport> {
  const qs = new URLSearchParams();
  if (params.from) qs.set("from", params.from);
  if (params.to) qs.set("to", params.to);
  const query = qs.toString();
  return requestJson<ClientOrdersReport>(
    `/api/v1/reports/sales/clients/${clientId}/orders${query ? `?${query}` : ""}`,
  );
}
